import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const WindowsCentral: Site = {
  id: 'windowscentral',
  logo: 'svg/windowscentral.svg',
  label: 'Windows Central',
  analyticsName: 'wp',
  hostname: 'windowscentral.com',
  platform: 'responsive',
  selector: `${responsiveVanillaSelector}, article a`,
};
